/**
 * @generated SignedSource<<892ddb80135be9b9fc71a226a92cabf1>>
 * @relayHash 1dd03fafadce36297794568c40fa153e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4ca22c49837400d3529f6a3ccc7d60af6cf56fea6078f4c23af57989435b41ce

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useAgentSessionsDataPaginationQuery$variables = {
  after?: string | null;
  aqlQuery: string;
  conversationWorkspaceAri: string;
  pageSize?: number | null;
  sharingContext: string;
  shouldReadSessions: boolean;
  sort?: string | null;
};
export type useAgentSessionsDataPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"useAgentSessionsData_query">;
};
export type useAgentSessionsDataPaginationQuery = {
  response: useAgentSessionsDataPaginationQuery$data;
  variables: useAgentSessionsDataPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aqlQuery"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "conversationWorkspaceAri"
  },
  {
    "defaultValue": 25,
    "kind": "LocalArgument",
    "name": "pageSize"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sharingContext"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "shouldReadSessions"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sort"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "aqlQuery",
  "variableName": "aqlQuery"
},
v3 = {
  "kind": "Variable",
  "name": "sort",
  "variableName": "sort"
},
v4 = [
  (v1/*: any*/),
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "pageSize"
  },
  {
    "kind": "Variable",
    "name": "shardingContext",
    "variableName": "sharingContext"
  },
  (v3/*: any*/)
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = [
  (v6/*: any*/),
  {
    "kind": "ScalarField",
    "name": "accountId"
  },
  (v7/*: any*/),
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useAgentSessionsDataPaginationQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "Variable",
            "name": "conversationWorkspaceAri",
            "variableName": "conversationWorkspaceAri"
          },
          {
            "kind": "Variable",
            "name": "pageSize",
            "variableName": "pageSize"
          },
          {
            "kind": "Variable",
            "name": "sharingContext",
            "variableName": "sharingContext"
          },
          {
            "kind": "Variable",
            "name": "shouldReadSessions",
            "variableName": "shouldReadSessions"
          },
          (v3/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "useAgentSessionsData_query"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useAgentSessionsDataPaginationQuery",
    "selections": [
      {
        "condition": "shouldReadSessions",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v4/*: any*/),
            "concreteType": "AgentSessionConnection",
            "kind": "LinkedField",
            "name": "agent_sessionQuery",
            "plural": false,
            "selections": [
              {
                "concreteType": "AgentSessionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "AgentSession",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "state"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "stateReason"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "expireTime"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "lastStateChangeAt"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "isRovo"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "agentAccountId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "convoAiAgentId"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "agent",
                        "plural": false,
                        "selections": (v8/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": (v8/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "name": "studioAgent",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "args": [
                          {
                            "kind": "Variable",
                            "name": "workspaceAri",
                            "variableName": "conversationWorkspaceAri"
                          }
                        ],
                        "concreteType": "AgentConversationChannel",
                        "kind": "LinkedField",
                        "name": "conversationChannel",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v7/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "lastAgentMessageStatus"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "readStatus"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isPlanning"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isPinned"
                          }
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "name": "associatedEntities",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "key"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "webUrl"
                              }
                            ],
                            "type": "JiraIssue"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "title"
                              },
                              {
                                "concreteType": "ConfluencePageLinks",
                                "kind": "LinkedField",
                                "name": "links",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "base"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "webUi"
                                  }
                                ]
                              }
                            ],
                            "type": "ConfluencePage"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v5/*: any*/)
                            ],
                            "type": "Node",
                            "abstractKey": "__isNode"
                          }
                        ]
                      },
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "cursor"
                  }
                ]
              },
              {
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "hasNextPage"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "endCursor"
                  }
                ]
              }
            ]
          },
          {
            "args": (v4/*: any*/),
            "filters": [
              "shardingContext",
              "aqlQuery",
              "sort"
            ],
            "handle": "connection",
            "key": "useAgentSessionsSnapshot_agent_sessionQuery",
            "kind": "LinkedHandle",
            "name": "agent_sessionQuery"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4ca22c49837400d3529f6a3ccc7d60af6cf56fea6078f4c23af57989435b41ce",
    "metadata": {},
    "name": "useAgentSessionsDataPaginationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "08ae022ae062f99dbdcdd4e316a75ae8";

export default node;
